import {
  ContactFormFieldStyle,
  ContactFormPublishMethod,
  IContactFormInvitation,
  IUpdateContactForm,
} from "api/settingsService";

export enum EWizardStep {
  FormStyle = 0,
  Publish = 1,
  SafeEnvelope = 2,
  Sharing = 3,
  AddressBook = 4,
  Secretariat = 5,
  Recipients = 6,
}

export const WIZARD_STEP_COUNT = 7;

export interface IContactFormWizardSettings {
  WorkspaceId?: string;
  Theme: number;

  Invitations: IContactFormInvitation[];
  RegistryOfficeUserIds: string[];
  ReceiverIds: string[];
  WorkspaceMemberIds: string[];

  BackgroundColor?: string;
  AccentColor?: string;
  LogoBlob?: Blob | null;

  FieldStyle: ContactFormFieldStyle;
  PublishMethod: ContactFormPublishMethod;

  HeaderTitle: string;
  ShowHeader: boolean;

  // Wizytówka — profil prywatny
  showPrivateName?: boolean;
  privateMailboxNumber?: string;
  // Wizytówka — profil biznesowy
  showBusinessCard?: boolean;
  nip?: string;
  companyName?: string;
  companyAddress?: string;
  shareAddress?: boolean;
  sharePublic?: boolean;
  shareInternal?: boolean;
  showBusinessMailboxNumber?: boolean;
  businessMailboxNumber?: string;
}

export type WizardSettingsPatch = Partial<IContactFormWizardSettings>;

export interface IContactFormWizardProps {
  open?: boolean;
  onClose?: () => void;
  /** Optional element rendered in the center of the canvas (e.g. live preview). */
  centerSlot?: React.ReactNode;
  /** Initial values when entering the wizard (e.g. existing form). */
  initialSettings?: Partial<IContactFormWizardSettings>;
  /** Notified whenever the user mutates the form — useful for the live preview. */
  onSettingsChange?: (settings: IContactFormWizardSettings) => void;
  /** Notified on successful Save (final "Zakończ" / step 6 publish). */
  onFinish?: (settings: IContactFormWizardSettings) => void;
  /** Pre-loaded workspace members — if provided, skips the internal fetch. */
  members?: import("dto/IWorkspace").IWorkspaceMember[];
  /** Render just the steps panel inline (no portal, no modal overlay). */
  inline?: boolean;
  /** Start with all accordion sections collapsed (only for inline mode). */
  startCollapsed?: boolean;
  /** Called whenever the active step changes. */
  onStepChange?: (step: EWizardStep) => void;
  /** Called whenever the expanded (visible) step changes — null means all collapsed. */
  onExpandedStepChange?: (step: EWizardStep | null) => void;
  /** Ref populated with the internal patchSettings — allows parent to push patches in inline mode. */
  patchSettingsRef?: React.MutableRefObject<
    (patch: WizardSettingsPatch) => void
  >;
  /** Ref populated with the internal finish callback — allows parent to trigger publish in inline mode. */
  finishRef?: React.MutableRefObject<() => void>;
}

export interface IWizardStepDef {
  id: EWizardStep;
  titleKey: string;
  descriptionKey: string;
  Icon: React.FC<React.SVGProps<SVGElement>>;
  Component: React.FC;
  /** Jeśli ustawione, przed tym krokiem renderowany jest nagłówek etapu. */
  stageLabel?: string;
}

export const DEFAULT_WIZARD_SETTINGS: IContactFormWizardSettings = {
  Theme: 0,
  Invitations: [],
  RegistryOfficeUserIds: [],
  ReceiverIds: [],
  WorkspaceMemberIds: [],
  BackgroundColor: undefined,
  AccentColor: undefined,
  LogoBlob: null,
  FieldStyle: "filled",
  PublishMethod: "link",
  HeaderTitle: "Wyślij przesyłkę szyfrowaną",
  ShowHeader: true,
  showPrivateName: false,
  privateMailboxNumber: "",
  showBusinessCard: false,
  nip: "",
  companyName: "",
  companyAddress: "",
  shareAddress: true,
  sharePublic: false,
  shareInternal: false,
  showBusinessMailboxNumber: false,
  businessMailboxNumber: "",
};

export const toBackendPayload = (
  s: IContactFormWizardSettings,
): IUpdateContactForm => ({
  WorkspaceId: s.WorkspaceId,
  Theme: s.Theme,
  RegistryOfficeUserIds: s.RegistryOfficeUserIds,
  ReceiverIds: s.ReceiverIds,
  WorkspaceMemberIds: s.WorkspaceMemberIds,
  Invitations: s.Invitations,
  BackgroundColor: s.BackgroundColor,
  AccentColor: s.AccentColor,
  FieldStyle: s.FieldStyle,
  PublishMethod: s.PublishMethod,
  HeaderTitle: s.HeaderTitle,
  ShowHeader: s.ShowHeader,
});
